module.exports = __webpack_public_path__ + "media/images/logo-0cdef23f13c0afacd0d53c698d44fff9.svg";